import { render, staticRenderFns } from "./NotesTasks.vue?vue&type=template&id=fb497eb6&"
import script from "./NotesTasks.vue?vue&type=script&lang=js&"
export * from "./NotesTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports